export default "__VITE_ASSET__BRPM76s8__"